<template>
    <div class="card-form">
            <div class="card-form__header">
                <div class="card-form__title">{{ localIsNew ? $t(labelCreate) : $t(labelEdit) }}</div>
                <v-btn
                        color="primary"
                        @click="submit()"
                        :disabled="localSubmitLoading"
                        :loading="localSubmitLoading"
                        small
                >{{ localIsNew ? $t('msg.toCreate') : $t('msg.save') }}</v-btn>
            </div>
            <v-progress-linear
                    v-if="localModelLoading"
                    :indeterminate="true"
            ></v-progress-linear>
            <v-form v-if="!localModelLoading">
                <slot></slot>
            </v-form>
            <div
                    v-if="!localModelLoading"
                    class="card-form__bottom">
                <v-btn
                        color="primary"
                        @click="submit()"
                        :disabled="localSubmitLoading"
                        :loading="localSubmitLoading"
                        small
                >{{ localIsNew ? $t('msg.toCreate') : $t('msg.save') }}</v-btn>
                <v-btn
                        v-if="localIsNew && labelCreateAndNext"
                        color="primary"
                        @click="submit(true)"
                        :disabled="localSubmitLoading"
                        :loading="localSubmitLoading"
                        small
                >{{ $t(labelCreateAndNext) }}</v-btn>
            </div>
    </div>
</template>

<script>
    export default {
        props: {
            model: Object,
            validator: null,
            formErrors: Object,
            routeEdit: String,
            actionLoad: String,
            actionCreate: String,
            actionEdit: String,
            successRoute: String,
            id: undefined,
            subId: undefined,
            isNew: undefined,
            submitLoading: null,
            modelLoading: null,
            labelCreate: {
                type: String,
                default: 'msg.create'
            },
            labelEdit: {
                type: String,
                default: 'msg.edit'
            },
            labelCreateAndNext: null,
            routeCreateAndNext: {
                type: Function,
                default: null
            },
            beforeSubmit: {
                type: Function,
                default: null
            }
        },
        data() {
            return {
                localSubmitLoading: this.submitLoading,
                localModelLoading: this.modelLoading,
                localIsNew: this.isNew,
                localId: this.id,
                localSubId: this.subId,
            }
        },
        watch: {
            isNew(v) {
                this.localIsNew = v;
            },
            localIsNew(v) {
                this.$emit('update:isNew', v)
            },
            id(v) {
                this.localId = v;
            },
            localId(v) {
                this.$emit('update:id', v)
            },
            subId(v) {
                this.localSubId = v;
                if (!this.localIsNew && this.localSubId !== null) this.loadModel();
            },
            localSubId(v) {
                this.$emit('update:subId', v)
            },
            submitLoading(v) {
                this.localSubmitLoading = v;
            },
            localSubmitLoading(v) {
                this.$emit('update:submitLoading', v)
            },
            modelLoading(v) {
                this.localSubmitLoading = v;
            },
            localModelLoading(v) {
                this.$emit('update:modelLoading', v)
            },
        },
        methods: {
            submit(nextStep) {
                this.validator.validateAll()
                    .then(res => {
                        if (res) {

                            this.localSubmitLoading = true;

                            const action = this.localIsNew ? this.actionCreate : this.actionEdit;
                            this.model.id = this.localIsNew ? null : this.model.id;

                            if (this.beforeSubmit !== null) this.beforeSubmit(this.model);

                            this.$store.dispatch(action, {
                                data: this.model,
                                id: this.localId,
                                subId: this.localSubId,
                                formErrors: this.formErrors
                            })
                                .then(res => {
                                    if (this.successRoute !== undefined) {
                                        if (nextStep && this.localIsNew && this.routeCreateAndNext) {
                                            this.$router.push(this.routeCreateAndNext({id: this.localId, subId: this.localSubId, newId: res.id}));
                                        } else {
                                            this.$router.push({name: this.successRoute});
                                        }
                                    }
                                    this.$emit('submitted');
                                })
                                .catch(() => this.scrollToError(this.formErrors))
                                .finally(() => this.localSubmitLoading = false);
                        } else {
                            this.scrollToError(this.formErrors);
                        }
                    });
            },
            loadModel() {
                if (this.localModelLoading) return;
                this.localModelLoading = true;

                this.$store.dispatch(this.actionLoad, {
                    id: this.localId,
                    subId: this.localSubId
                })
                    .then(res => {
                        this.$emit('update:model', res);
                    })
                    .finally(() => this.localModelLoading = false);
            },
        },
        created() {
            if (this.localIsNew === undefined) this.localIsNew = this.$route.name !== this.routeEdit;

            if (this.localId === undefined) this.localId = this.$route.params.id;

            if (this.localSubId === undefined) this.localSubId = this.$route.params.sub_id;

            if (!this.localIsNew) {
                this.loadModel();
            }
        }
    }
</script>

<style lang="scss">
    .card-form {
        &.card-form_max-xs {
            max-width: 600px;
        }
        &.card-form_max-sm {
            max-width: 960px;
        }
        &.card-form_max-md {
            max-width: 1264px;
        }
        &.card-form_max-lg {
            max-width: 1904px;
        }
        .card-form__header {
            border-bottom: 1px solid #eee;
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            margin-bottom: 15px;
        }
        .card-form__title {
            font-size: 15px;
            color: rgba(0, 0, 0, 0.87);
            margin: 5px 5px 5px 0;
        }
        .card-form__bottom {
            display: flex;
            justify-content: flex-end;
            padding-top: 20px;
            padding-bottom: 10px;

            button {
                margin-right: 10px;

                &:last-child {
                    margin-right: 0;
                }
            }
        }
    }
</style>